export enum NotificationsActionTypes {
    TRIGGER_NOTIFICATION = '@@edikit/notifications/TRIGGER_NOTIFICATION',
    CLOSE_NOTIFICATION   = '@@edikit/notifications/CLOSE_NOTIFICATION',
}



// WEBPACK FOOTER //
// ./src/edikit/notifications/store/types.ts